

export default {
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
    SET_MEDSOS(state, payload){
        state.medsosList = payload
    }
}
